import angular from 'angular'
import baseTemp from './views/baseTemplate.html'
import taxClassTemp from './views/taxClassTemplate.html'

const popupSelectModule = angular
    .module('app.popupSelect', [])

export default popupSelectModule.name
popupSelectModule.component('popupSelect', {
    template: `<div class="clearfix et-popup-select">
        <input autocomplete="off" type="text" class="form-control f-fl et-popup-select-ipt" ng-model="$ctrl.model[$ctrl.keyword]" ng-if="$ctrl.type!='taxClass'" name="$ctrl[$ctrl.keyword]" uib-typeahead="n[$ctrl.keyword] as  n.code+' '+n.name for n in $ctrl.nameList | popupSelectFilter:$viewValue" typeahead-loading="loadingLocations" typeahead-no-results="$ctrl.noResults" typeahead-on-select="$ctrl.getNameInfo($item, $model, $label, $event)" required ng-blur="$ctrl.blurFn($ctrl.noResults)">
        <input autocomplete="off" type="text" ng-model="$ctrl.model[$ctrl.keyword]" class="form-control f-fl et-popup-select-ipt"  uib-typeahead="n.taxName as n.mergeCodeAndTaxName for n in $ctrl.getTaxClassList($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="$ctrl.noResults" typeahead-on-select="$ctrl.getTaxClassInfo($item, $model, $label, $event)" required ng-if="$ctrl.type=='taxClass'" name="$ctrl.name">
        <div class="et-popup-select-icon f-fl" ng-click="$ctrl.openPop()" style="border-left:none;">
            <i class="icon iconfont icon-shurukuangtanchuang"></i>
        </div>
    </div>`,

    // <div ng-show="$ctrl.noResults&&$ctrl.type=='taxClass'" class="require-red f-fl et-pop-required">
    //     <i class="glyphicon glyphicon-remove"></i> 无该税收分类名称
    // </div>
    /**
     *
     *          type  弹窗类型             string
     *          model 双向绑定的对象        object
     *          code  string 非必传 区分taxClass是否为车辆税收编码
     *          params taxClass 【ID1006204】【商品信息】新增商品，选择税分编码时，可以自动带入之前填写的商品名称进行检索   {queryParam: ''}
     */
    bindings: {
        type: '@',
        model: '=',
        callback: '&',
        code: '@',
        params: '<',
    },
    controller: ['$uibModal', 'httpRequest', '$http', '$timeout', function ($uibModal, httpRequest, $http, $timeout) {
        // 基础弹窗controller
        const baseModalFn = ($scope, $uibModalInstance, httpRequest, $timeout, config) => {
            $scope.cancel = () => {
                $uibModalInstance.dismiss()
            }
            $scope.tableList = config.tableList
            $scope.isDouble = config.isDouble
            $scope.listData = []
            $scope.queryParam = {
                pageSize: 10,
                pageNum: 1,
                param: {
                    allStr: '',
                },
            }
            // 获取弹窗数据
            const httpReqFn = () => {
                let promise = null
                switch (config.code) {
                case 'buyerInfo':
                    $scope.queryParam.param.status = 1
                    promise = httpRequest.post_getPageCustomerList($scope.queryParam).then((res) => {
                        if (res.data.success) {
                            $scope.listData = res.data.value.list
                            $scope.totalItems = res.data.value.total
                        }
                    })
                    break
                case 'field':
                    // $scope.queryParam.param = ''
                    promise = httpRequest.post_getVehicleOriginList($scope.queryParam).then((res) => {
                        if (res.data.success) {
                            $scope.listData = res.data.value.list
                            $scope.totalItems = res.data.value.total
                        }
                    })
                    break
                case 'manufacturerName':
                    // $scope.queryParam.param = ''
                    promise = httpRequest.post_getSysVehicleCompanyList($scope.queryParam).then((res) => {
                        if (res.data.success) {
                            $scope.listData = res.data.value.list
                            $scope.totalItems = res.data.value.total
                        }
                    })
                    break
                case 'carInfo':
                    httpRequest.get_dictByTypeArr(['is_privilege']).then((res) => {
                        $scope.dictData = res.data.value
                    })
                    $scope.queryParam.param.status = 1
                    promise = httpRequest.post_pageVehicleGood($scope.queryParam).then((res) => {
                        if (res.data.success) {
                            $scope.listData = res.data.value.list
                            $scope.totalItems = res.data.value.total
                        }
                    })
                    $scope.taxRatePercent = function taxRatePercent(val) {
                        if (+val === val) {
                            val = `${val * 100}%`
                        }
                        return val
                    }
                    break
                case 'goodsInfo':
                    $scope.queryParam.param.status = 1
                    promise = httpRequest.post_pageGoodsInfo($scope.queryParam).then((res) => {
                        if (res.data.success) {
                            $scope.listData = res.data.value.list
                            $scope.totalItems = res.data.value.total
                        }
                    })
                    $scope.taxRatePercent = function taxRatePercent(val) {
                        if (+val === val) {
                            val = `${val * 100}%`
                        }
                        return val
                    }
                    break
                default:
                    // 商品信息车辆类型
                    promise = httpRequest.post_getVehicleTypeList($scope.queryParam).then((res) => {
                        if (res.data.success) {
                            $scope.listData = res.data.value.list
                            $scope.totalItems = res.data.value.total
                        }
                    })
                    break
                }
                return promise
            }
            // 获取数据后计算单元格宽度
            $scope.queryList = function queryList() {
                httpReqFn().then(() => {
                    $timeout(() => {
                        // 计算表格宽度与每个表格单元格宽度
                        const tableWidth = config.modalSize == 'sm' ? 560 : 840
                        const cellWidth = `${tableWidth / $scope.tableList.length - 10}px`
                        $('#popup-select-table th,#popup-select-table td').css('width', cellWidth)
                    })
                })
            }
            $scope.queryList()
            $scope.title = config.title
            $scope.model = config.model
            // 返回选中的对象
            $scope.ok = (obj) => {
                $uibModalInstance.close(obj)
            }
        }
        // 税收编码输入选择匹配数据
        this.getTaxClassList = function getTaxClassList(val) {
            if (this.type === 'taxClass' && this.code === 'car') {
                return $http.get(`${host.etcloudOvat}settings/sysVehicleGood/qryVehicleTaxClassList`, {
                    params: {
                        taxName: `${val}`,
                    },
                }).then((response) => response.data.value.map((item) => $.extend({}, {
                    mergeCodeAndTaxName: `${item.mergeCode}${item.taxName}`,
                }, item)))
            }
            return $http.get(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/getTaxClassList`, {
                params: {
                    taxName: `${val}`,
                },
            }).then((response) => response.data.value.map((item) => $.extend({}, {
                mergeCodeAndTaxName: `${item.mergeCode}${item.taxName}`,
            }, item)))
        }
        // 税收编码输入选择匹配后的逻辑
        this.getTaxClassInfo = function () {
            $http.get(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/getTaxClassInfo`, {
                params: {
                    taxName: this.model[this.keyword],
                },
            }).then((res) => {
                $timeout(() => {
                    this.model = res.data.value
                })
                this.callback && this.callback()
            })
        }
        // 普通输入选择匹配后的逻辑
        this.getNameInfo = function getNameInfo($item) {
            // $timeout(() => {
            this.model = $item
            // })
            this.callback && this.callback({ $item })
        }
        // 失去焦点逻辑
        this.blurFn = function blurFn(v) {
            if (v && this.notSave) this.model[this.keyword] = ''
        }
        // 通过type匹配对应弹窗参数
        const config = {
            taxClass: {
                title: '税收分类编码选择',
                // 税收编码弹窗方法
                modalFn: function modalFn($scope, $uibModalInstance, httpRequest, $timeout, config) {
                    $scope.cancel = () => {
                        $uibModalInstance.dismiss()
                    }
                    httpRequest.get_dictByTypeArr(['is_sum']).then((res) => {
                        $scope.dictData = res.data.value
                    })
                    $scope.queryParam = {
                        pageNum: 1,
                        pageSize: 10,
                        param: {
                            pid: '',
                            allStr: config.modalFnQueryParam || '',
                            type: config.type,
                            deep: true,
                        },
                    }
                    $scope.isClosed = false
                    $scope.tableList = config.tableList
                    $scope.listData = []
                    $scope.queryList = function queryList() {
                        httpRequest.post_getSysTaxClassList($scope.queryParam).then((res) => {
                            if (res.data.success) {
                                $scope.listData = res.data.value.list
                                $scope.totalItems = res.data.value.total
                            }
                        })
                    }
                    $scope.queryList()
                    // 初始树结构获取
                    httpRequest.post_getSysTaxClassList({
                        pageNum: 1,
                        pageSize: 10,
                        param: {
                            pid: 0,
                        },
                    }).then((res) => {
                        if (res.data.success) {
                            $scope.treeListData = res.data.value.list
                        }
                    })
                    /**
                     * 树切换方法，无参数为总目录切换，传参为子目录切换
                    */
                    $scope.toggleTree = function toggleTree(e, obj) {
                        $('.pop-tree-text').removeClass('et-pop-select-acitve')
                        if (arguments.length) {
                            obj.isOpened = !obj.isOpened
                            // 添加active类名
                            if ($(e.target).parent('div').length) {
                                $(e.target).parent('div').children('.pop-tree-text').addClass('et-pop-select-acitve')
                            } else {
                                $(e.target).children('.pop-tree-text').addClass('et-pop-select-acitve')
                            }
                        } else {
                            $scope.isClosed = !$scope.isClosed
                            $('.tax-class-tree').children('div').children('.pop-tree-text').addClass('et-pop-select-acitve')
                        }
                        // 发送请求插入子目录数据
                        $scope.queryParam.param.pid = obj ? obj.mergeCode : ''
                        httpRequest.post_getSysTaxClassList({
                            pageNum: 1,
                            pageSize: 0,
                            param: {
                                pid: $scope.queryParam.param.pid,
                            },
                        }).then((res) => {
                            if (res.data.success) {
                                if (obj) obj.treeListData = res.data.value.list
                            }
                        })
                        httpRequest.post_getSysTaxClassList($scope.queryParam).then((res) => {
                            if (res.data.success) {
                                $timeout(() => {
                                    $scope.listData = res.data.value.list
                                    $scope.totalItems = res.data.value.total
                                })
                            }
                        })
                    }
                    $scope.title = config.title
                    $scope.model = config.model
                    $scope.ok = (obj) => {
                        // 调用接口使返回数据与输入匹配数据结构一致
                        if (!obj.taxRate) return
                        $http.get(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/qryTaxClassInfo`, {
                            params: {
                                taxMergeCode: obj.mergeCode,
                            },
                        }).then((res) => {
                            $uibModalInstance.close(res.data.value)
                        })
                    }
                },
                tableList: [
                    { name: '编码', keywords: 'taxCode' },
                    { name: '合并编码', keywords: 'mergeCode' },
                    { name: '名称', keywords: 'taxName' },
                    { name: '简称', keywords: 'taxShortName' },
                    { name: '说明', keywords: 'memo' },
                    { name: '税率', keywords: 'taxRate' },
                    { name: '增值税特殊管理', keywords: 'taxSpecialManage' },
                    { name: '消费税管理', keywords: 'taxExciseManage' },
                    { name: '关键字', keywords: 'keyword' },
                    { name: '增值税政策依据', keywords: 'taxSpecialPolicybasis' },
                    { name: '汇总项', keywords: 'isSum' },
                ],
                modalClass: 'mod-modal mod-modal-hg',
                temp: taxClassTemp,
            },
            carType: {
                modalFn: baseModalFn,
                title: '车辆类型',
                tableList: [
                    { name: '车辆种类代码', keywords: 'code' },
                    { name: '车辆大类名称', keywords: 'classname' },
                    { name: '车辆种类名称', keywords: 'name' },
                ],
                modalClass: 'mod-modal mod-modal-lg',
                temp: baseTemp,
                modalSize: 'sm',
                code: 'carType',
            },
            field: {
                modalFn: baseModalFn,
                title: '产地',
                tableList: [
                    { name: '产地名称', keywords: 'name' },
                    { name: '产地代码', keywords: 'code' },
                    { name: '产地简称', keywords: 'briefname' },
                ],
                modalClass: 'mod-modal mod-modal-lg',
                temp: baseTemp,
                modalSize: 'sm',
                code: 'field',
            },
            carInfo: {
                modalFn: baseModalFn,
                title: '车辆信息',
                tableList: [
                    { name: '编码', keywords: 'code' },
                    { name: '车辆类型', keywords: 'vehicleType' },
                    { name: '厂牌型号', keywords: 'brandmode' },
                    { name: '产地', keywords: 'place' },
                    { name: '生产企业名称', keywords: 'enterpriseName' },
                    { name: '税收合并编码', keywords: 'taxMergeCode' },
                    { name: '是否享受优惠政策', keywords: 'isPrivilege' },
                    { name: '优惠政策类型', keywords: 'privilegeType' },
                    { name: '税率', keywords: 'taxRate' },
                ],
                modalClass: 'mod-modal mod-modal-hg',
                temp: baseTemp,
                code: 'carInfo',
                isDouble: false,
            },
            goodsInfo: {
                modalFn: baseModalFn,
                title: '商品信息',
                tableList: [
                    { name: '编码', keywords: 'goodsCode' },
                    { name: '名称', keywords: 'goodsName' },
                    { name: '规格型号', keywords: 'specifications' },
                    { name: '税率', keywords: 'taxRate' },
                    { name: '计量单位', keywords: 'measureUnit' },
                    { name: '单价', keywords: 'price' },
                    { name: '含税标识', keywords: 'taxInclud' },
                    { name: '税收分类编码', keywords: 'taxMergeCode' },
                    { name: '是否享受优惠政策', keywords: 'isPrivilege' },
                    { name: '优惠政策类型', keywords: 'privilegeType' },
                ],
                modalClass: 'mod-modal mod-modal-hg',
                temp: baseTemp,
                code: 'goodsInfo',
            },
            buyerInfo: {
                modalFn: baseModalFn,
                title: '购方信息',
                tableList: [
                    { name: '编码', keywords: ['customerCode'] },
                    { name: '名称', keywords: ['customerName'] },
                    { name: '纳税人识别号', keywords: ['creditCode'] },
                    { name: '地址电话', keywords: ['businessAddress', 'phone'] },
                    { name: '银行账号', keywords: ['bank', 'bankAccount'] },
                    { name: '身份证号码/组织机构代码', keywords: ['certificateNo'] },
                ],
                modalClass: 'mod-modal mod-modal-hg',
                temp: baseTemp,
                code: 'buyerInfo',
                isDouble: true,
            },
            manufacturerName: {
                modalFn: baseModalFn,
                title: '生产企业名称',
                tableList: [
                    { name: '生产企业代码', keywords: 'code' },
                    { name: '产地代码', keywords: 'productcode' },
                    { name: '生产企业名称', keywords: 'name' },
                    { name: '生产企业简称', keywords: 'briefname' },
                    { name: '主管税务机关代码', keywords: 'directortaxcode' },
                ],
                modalClass: 'mod-modal mod-modal-hg',
                temp: baseTemp,
                code: 'manufacturerName',
            },
        }
        config.buyerInfoCustName = config.buyerInfo
        config.buyerInfoCustIdentifyNo = config.buyerInfo
        config.buyerInfoCustCreditCode = config.buyerInfo
        // 组件初始化钩子
        this.$onInit = function () {
            // 税收编码组件区分类别
            config.taxClass.type = this.code == 'car' ? 1 : ''
            // 定义组件显示的字段
            switch (this.type) {
            case 'taxClass':
                this.keyword = 'taxName'
                this.notSave = true
                break
            case 'carInfo':
                this.keyword = 'vehicleType'
                this.notSave = true
                break
            case 'buyerInfoCustName':
                this.keyword = 'customerName'
                break
            case 'buyerInfoCustIdentifyNo':
                this.keyword = 'certificateNo'
                break
            case 'buyerInfoCustCreditCode':
                this.keyword = 'creditCode'
                break
            case 'goodsInfo':
                this.keyword = 'shortAndMatName'
                this.notSave = true
                break
            default:
                this.keyword = 'name'
                break
            }
            this.queryParam = {
                pageSize: 100,
                pageNum: 1,
                param: {
                    allStr: '',
                },
            }
            // 获取输入下拉匹配数据
            switch (this.type) {
            case 'buyerInfoCustCreditCode':
                this.queryParam.param.status = 1
                httpRequest.post_getPageCustomerList(this.queryParam).then((res) => {
                    if (res.data.success) {
                        this.nameList = res.data.value.list
                        this.nameList.forEach((element) => {
                            element.code = element.creditCode
                            element.name = element.customerName
                        })
                    }
                })
                break
            case 'buyerInfoCustIdentifyNo':
                this.queryParam.param.status = 1
                httpRequest.post_getPageCustomerList(this.queryParam).then((res) => {
                    if (res.data.success) {
                        this.nameList = res.data.value.list
                        this.nameList.forEach((element) => {
                            element.code = element.certificateNo
                            element.name = element.customerName
                        })
                    }
                })
                break
            case 'buyerInfoCustName':
                this.queryParam.param.status = 1
                httpRequest.post_getPageCustomerList(this.queryParam).then((res) => {
                    if (res.data.success) {
                        this.nameList = res.data.value.list
                        this.nameList.forEach((element) => {
                            element.code = element.customerCode
                            element.name = element.customerName
                        })
                    }
                })
                break
            case 'field':
                // 产地
                httpRequest.post_getVehicleOriginList(this.queryParam).then((res) => {
                    if (res.data.success) {
                        this.nameList = res.data.value.list
                    }
                })
                break
            case 'manufacturerName':
                // 生成企业名称
                httpRequest.post_getSysVehicleCompanyList(this.queryParam).then((res) => {
                    if (res.data.success) {
                        this.nameList = res.data.value.list
                    }
                })
                break
                // 机动车车辆类型
            case 'carInfo':
                this.queryParam.param.status = 1
                httpRequest.post_pageVehicleGood(this.queryParam).then((res) => {
                    if (res.data.success) {
                        this.nameList = res.data.value.list
                        this.nameList.forEach((item) => {
                            item.name = item.vehicleType
                        })
                    }
                })
                break
                // 商品信息，卷票项目
            case 'goodsInfo':
                this.queryParam.param.status = 1
                httpRequest.post_pageGoodsInfo(this.queryParam).then((res) => {
                    if (res.data.success) {
                        this.nameList = res.data.value.list
                        this.nameList.forEach((item) => {
                            item.code = item.goodsCode
                            item.name = item.goodsName
                        })
                    }
                })
                break
            case 'carType':
                // 商品信息车辆类型
                httpRequest.post_getVehicleTypeList(this.queryParam).then((res) => {
                    this.nameList = res.data.value.list
                })
                break
            }
        }
        this.openPop = function () {
            const _that = this
            if (this.type === 'taxClass' && this.params) { config.taxClass.modalFnQueryParam = this.params.queryParam || '' }
            $uibModal.open({
                template: config[this.type].temp,
                openedClass: config[this.type].modalClass,
                controller: ['$scope', '$uibModalInstance', 'httpRequest', '$timeout', 'config', config[this.type].modalFn],
                animation: true,
                resolve: {
                    config() {
                        return config[_that.type]
                    },
                },
            }).result.then((obj) => {
                $timeout(() => {
                    this.model = obj
                })
                this.callback && this.callback({ $item: obj })
            })
        }
    }],
})



// WEBPACK FOOTER //
// ./src/components/popupSelect/index.js